import './App.css';
import MenuPage from './page/MenuPage';

function App() {
  return (
    <div className="App">
      <MenuPage />
    </div>
  );
}

export default App;
